var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWhiteboard = function SvgWhiteboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3.75H3v10.5h18V3.75ZM3 2.25a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h18a1.5 1.5 0 0 0 1.5-1.5V3.75a1.5 1.5 0 0 0-1.5-1.5H3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.305 14.315a.75.75 0 0 1 .38.99l-3 6.75a.75.75 0 0 1-1.37-.61l3-6.75a.75.75 0 0 1 .99-.38ZM14.695 14.315a.75.75 0 0 0-.38.99l3 6.75a.75.75 0 0 0 1.37-.61l-3-6.75a.75.75 0 0 0-.99-.38Z"
  })));
};

export default SvgWhiteboard;